import { useState, type ReactNode } from 'react';

/**
 * A marca do produto no trilho.
 *
 * ── Por que o recuo, e não só a imagem ────────────────────────────────────
 *
 * O arquivo `/marca.svg` é solto no diretório `public/` por quem cuida da
 * identidade, e pode não estar lá — num ambiente novo, num clone, ou antes de
 * a arte ficar pronta. Imagem quebrada no canto superior é a primeira coisa
 * que a pessoa vê ao entrar, e diz "produto malfeito" antes de qualquer tela.
 *
 * Com o recuo, a ausência do arquivo é invisível: aparece o selo com a
 * inicial, que é o que existe hoje. Quando o arquivo chegar, ele aparece
 * sozinho — sem tocar em código.
 */
export function Marca(): ReactNode {
  const [semImagem, definirSemImagem] = useState(false);

  return (
    <div className="casca__marca">
      {/*
        O logo CLARO, e não o roxo: o roxo da marca sobre a tinta dá 1,92:1 e o
        "CLIQ" some. Recolhido, quem aparece é o símbolo — e ele é outro
        elemento, o botão que expande, porque mostrar os dois ao mesmo tempo
        repetiria o Q com o cursor: o lockup já o contém.
      */}
      {semImagem ? null : (
        <img
          className="casca__logo"
          src="/marca/logo-cliqcrm-claro.png"
          alt="CliqCRM"
          onError={() => definirSemImagem(true)}
        />
      )}
      {/*
        O nome escrito é a RESERVA: só aparece se a imagem não carregar. Com o
        logo, ele já está dentro dela — repetir ao lado seria escrever
        "CliqCRM CliqCRM".
      */}
      {semImagem && <span className="casca__marca-nome">CliqCRM</span>}
    </div>
  );
}
